import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { VendordashboardService } from 'src/app/services/dashboard/vendor/vendordashboard.service';
import { Vendordata } from 'src/app/model/vendordata.model';
import { isNullOrUndefined } from 'util';
import { isNull } from '@angular/compiler/src/output/output_ast';
import { Observable } from 'rxjs'
import { BehaviorSubject } from 'rxjs';
import { EnlistmentService } from 'src/app/services/enlistment/enlistment.service';
import { Prevendor } from 'src/app/model/prevendor.model';
import { NgForm, FormsModule } from '@angular/forms';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpErrorResponse } from '@angular/common/http';
import { distinctUntilChanged } from 'rxjs/operators';
import { Binary } from '@angular/compiler';
import { ReplaySubject } from 'rxjs';
import { Gst } from 'src/app/model/gst.model';
import { EvaluationService } from 'src/app/services/evaluation/evaluation.service';
import { Vendorevaluation } from 'src/app/model/vendorevaluation.model';

@Component({
  selector: 'app-vendorscore',
  templateUrl: './vendorscore.component.html',
  styleUrls: ['./vendorscore.component.css']
})
export class VendorscoreComponent implements OnInit {

  currentUserData: any;
  vendorData: any;
  vModelData: Vendordata;
  vEvaluationData: Vendorevaluation;
  stepno: string;
  applicationref: string;
  returnData: any;
  tiers: Gst[] = [];
  isUserPurchase: boolean;
  isUserFinance: boolean;

  constructor(private router: Router, private userService: UserService,
    private dataSharingService: DataSharingService, private vendorDashboardService: VendordashboardService,
    private enlistmentServices: EnlistmentService, private evaluationService: EvaluationService,
    private route: ActivatedRoute) {
    this.vModelData = new Vendordata();
    this.stepno = this.route.snapshot.params.stepno;
    this.applicationref = this.route.snapshot.params.applicationrefno;

    this.userService.isUserFinance.subscribe(
      value => {
        this.isUserFinance = value;
      });
    this.userService.isUserPurchase.subscribe(
      value => {
        this.isUserPurchase = value;
      }
    );
  }

  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userdata) => {
        this.currentUserData = userdata;
        if (this.currentUserData != null) {

          var currentUserId = this.currentUserData.id;

          // this.evaluationService.getVendorData(this.applicationref).subscribe(
          //   (data) => {
          //     this.vendorData = data;
          //     this.vModelData = this.vendorData;
          //     console.log(this.vModelData);
          //   }
          // )

          this.evaluationService.getVendorDataForScoreObservation(this.applicationref).subscribe(
            (data) => {
              this.vendorData = data;
              this.vEvaluationData = this.vendorData;
              this.vEvaluationData.rDSetupObservation = true;
              this.vEvaluationData.tPOwnedByVendor = "adequate";
              console.log(this.vendorData);
            }
          )

        }
      }
    );

  }

  SubmitVendorScoreForm(form: NgForm) {

    console.log(form.value);

    if(isNullOrUndefined(form.value.approvedBySupplyChain))
    {
      form.value.approvedBySupplyChain = this.vendorData.approvedBySupplyChain;
      form.value.remarksBySupplyChain = this.vendorData.remarksBySupplyChain;
      form.value.approveDateSupplyChain = this.vendorData.approveDateSupplyChain;
    }

    if(isNullOrUndefined(form.value.approvedByFinance))
    {
      form.value.approvedByFinance = this.vendorData.approvedByFinance;
      form.value.remarksByFinance = this.vendorData.remarksByFinance;
      form.value.approveDateFinance = this.vendorData.approveDateFinance;
    }


    this.evaluationService.saveEvaluationScoreData(form.value).subscribe(
      (data: any) => {
        console.log(data);
        alert(data.message);

      }
    )

  }

}
